<template>
    <input ref="inputElement" type="text" v-model="model" class="form-control" :maxlength="maxLength" />
</template>

<script setup lang="ts">
    import { ref } from "vue";

    defineProps<{
        maxLength?: number;
    }>();

    const model = defineModel<string | undefined>({ required: true });
    const inputElement = ref<HTMLInputElement | null>(null);

    function setError(hasError: boolean) {
        if (inputElement.value) {
            inputElement.value.classList.toggle("is-invalid", hasError);
        }
    }

    defineExpose({
        setError,
    });
</script>
